
/* M-Tech custom BMW tuning product pages | Turbo 11.0.0 | scope: [data-mtech-tuning] */
(function () {
  'use strict';
  var HARDWARE = [
    ['Stock turbo', 0],
    ['Upgraded turbo', 750],
    ['Port injection installed', 750],
    ['Upgraded turbo + port injection', 750],
    ['Built motor', 900],
    ['Built motor + port injection', 900]
  ];
  var EXTRA = [
    ['None', 0],
    ['Fixed E50', 250],
    ['Flex up to E50', 350],
    ['Full E85', 0]
  ];
  var MAX_MAPS = 20;

  function setup(root) {
    if (root.dataset.ready === 'yes') return;
    root.dataset.ready = 'yes';
    var platform = root.dataset.platform;
    var variants = JSON.parse(root.querySelector('[data-tuning-variants]').textContent);
    var maps = JSON.parse(root.querySelector('[data-map-variants]').textContent);
    var form = root.querySelector('[data-config-form]');
    var state = { engine:'B58', base:'93', hardware:'Stock turbo', extra:'None', mapCount:0 };
    var buying = false;
    var el = function (q) { return root.querySelector('[data-' + q + ']'); };
    var mapRequestFields = [];

    function createMapRequestFields() {
      var wrapper = document.createElement('div');
      wrapper.style.borderTop = '1px solid #d6dfeb';
      wrapper.style.marginTop = '16px';
      wrapper.style.paddingTop = '16px';

      var heading = document.createElement('p');
      heading.className = 'mtech-tuning__field';
      heading.textContent = 'Custom Map Requests (Optional)';
      wrapper.appendChild(heading);

      var help = document.createElement('p');
      help.className = 'mtech-tuning__small';
      help.textContent = 'Describe any map preferences, such as fuel, burble, flames, or other calibration requests. Map 1 is included with your base tune. Maps 2-4 become editable as you purchase additional custom maps above. All requests are subject to tuner review.';
      help.style.marginBottom = '14px';
      wrapper.appendChild(help);

      for (var index = 1; index <= MAX_MAPS + 1; index++) {
        var field = document.createElement('label');
        field.className = 'mtech-tuning__field';
        field.hidden = index > 4;
        var title = document.createElement('span');
        title.textContent = 'Map ' + index + (index === 1 ? ' (Base Tune)' : ' (Additional Map)');
        var input = document.createElement('input');
        input.type = 'text';
        input.maxLength = 250;
        input.autocomplete = 'off';
        input.placeholder = 'e.g., fuel, burble, flames, or other map preference';
        input.disabled = index > 1;
        field.appendChild(title);
        field.appendChild(input);
        wrapper.appendChild(field);
        mapRequestFields.push({ index: index, field: field, input: input });
      }
      el('mods').closest('.mtech-tuning__field').insertAdjacentElement('afterend', wrapper);
    }

    function updateMapRequestFields() {
      var purchasedMapSlots = 1 + state.mapCount;
      mapRequestFields.forEach(function (slot) {
        slot.field.hidden = slot.index > 4 && slot.index > purchasedMapSlots;
        slot.input.disabled = slot.index > purchasedMapSlots;
        slot.field.style.opacity = slot.input.disabled ? '0.55' : '1';
      });
    }

    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency', currency: root.dataset.shopCurrency || 'USD', minimumFractionDigits: 2
    });
    function cash(cents) { return formatter.format((cents || 0) / 100); }
    function isS63() { return state.engine === 'S63'; }
    function hasPI() { return /port injection/i.test(state.hardware); }

    function findVariant() {
      return variants.find(function (v) {
        return v.engine === state.engine &&
          v.hardware === (isS63() ? 'S63 Standard' : state.hardware) &&
          v.extra === state.extra;
      });
    }

    function findMap() {
      var engine = isS63() ? 'S63' : 'B58/S58';
      return maps.find(function (v) { return v.engine === engine; });
    }

    function expectedPrice() {
      if (isS63()) return 135000 + (state.extra === 'Fixed E50' ? 35000 : 0);
      var hardware = HARDWARE.find(function (x) { return x[0] === state.hardware; });
      var fuel = EXTRA.find(function (x) { return x[0] === state.extra; });
      return 100000 + (hardware ? hardware[1] * 100 : 0) + (fuel ? fuel[1] * 100 : 0);
    }

    function radioChoices(container, name, choices, selected, handler) {
      container.innerHTML = '';
      choices.forEach(function (choice, index) {
        var label = document.createElement('label');
        label.className = 'mtech-tuning__option';
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'mtech-' + name + '-' + root.dataset.sectionId;
        input.value = choice[0];
        input.checked = choice[0] === selected;
        input.addEventListener('change', function () {
          if (input.checked) handler(input.value);
        });
        label.appendChild(input);
        var text = document.createElement('span');
        text.textContent = choice[1];
        label.appendChild(text);
        container.appendChild(label);
      });
    }

    function showError(message) {
      var box = el('error');
      box.textContent = message || '';
      box.hidden = !message;
    }

    function refresh() {
      var s63 = isS63();

      radioChoices(el('engine-options'), 'engine', [
        ['B58', 'B58 | Starting at $1,000'],
        ['S58', 'S58 | Starting at $1,000'],
        ['S63', 'S63 | Starting at $1,350']
      ], state.engine, function (v) {
        state.engine = v;
        state.base = '93';
        state.hardware = 'Stock turbo';
        state.extra = 'None';
        state.mapCount = 0;
        mapRequestFields.forEach(function (slot) { slot.input.value = ''; });
        refresh();
      });

      radioChoices(el('base-options'), 'base', [
        ['87', '87 Octane | Included'],
        ['91', '91 Octane | Included'],
        ['93', '93 Octane | Included']
      ], state.base, function (v) {
        state.base = v;
        refresh();
      });

      el('hardware-group').hidden = s63;
      el('extra-group').hidden = false;

      if (!s63) {
        radioChoices(el('hardware-options'), 'hardware', HARDWARE.map(function (h) {
          return [h[0], h[0] + (h[1] ? ' | +' + cash(h[1] * 100) : ' | Included')];
        }), state.hardware, function (v) {
          state.hardware = v;

          // Port-injection builds automatically select Full E85.
          // Returning to non-PI hardware restores normal fuel options.
          if (hasPI()) {
            state.extra = 'Full E85';
          } else if (state.extra === 'Full E85') {
            state.extra = 'None';
          }

          refresh();
        });
      }

      // All B58/S58 configurations with port injection automatically
      // use Full E85 as their sole additional fuel calibration.
      // No additional fuel charge applies.

      if (!s63 && hasPI()) {
        state.extra = 'Full E85';
      }

      var fuelChoices = s63 ? [
        ['None', 0],
        ['Fixed E50', 350]
      ] : hasPI() ? [
        ['Full E85', 0]
      ] : EXTRA.filter(function (e) {
        return e[0] !== 'Full E85';
      });

      radioChoices(el('extra-options'), 'extra', fuelChoices.map(function (e) {
        return [
          e[0],
          e[0] === 'Full E85'
            ? 'Flex Fuel Full E85 | Included with port injection calibration'
            : e[0] + (e[1] ? ' | +' + cash(e[1] * 100) : ' | No additional calibration') +
              (e[0] === 'Flex up to E50' ? ' | must have flex fuel kit installed' : '')
        ];
      }), state.extra, function (v) {
        state.extra = v;
        refresh();
      });

      el('map-count').textContent = state.mapCount;
      updateMapRequestFields();

      var mapVariant = findMap();
      var hasMap = mapVariant &&
        mapVariant.available &&
        mapVariant.price === (s63 ? 35000 : 25000);

      el('maps-minus').disabled = state.mapCount <= 0 || buying;
      el('maps-plus').disabled = !hasMap || state.mapCount >= MAX_MAPS || buying;

      el('map-rate').textContent = hasMap
        ? cash(mapVariant.price) + ' each'
        : 'Extra maps unavailable until the add-on product is configured';

      var baseVariant = findVariant();
      var priceOK = !!(
        baseVariant &&
        baseVariant.available &&
        baseVariant.price === expectedPrice()
      );

      el('total').textContent = cash(
        (baseVariant ? baseVariant.price : expectedPrice()) +
        state.mapCount * (hasMap ? mapVariant.price : 0)
      );

      el('summary').textContent =
        'Engine: ' + state.engine +
        '\nBase fuel: ' + state.base + ' octane' +
        '\nHardware: ' + (s63 ? 'S63 Standard' : state.hardware) +
        '\nAdditional fuel: ' + state.extra +
        '\nAdditional custom maps: ' + state.mapCount;

      var requiresReview = platform === 'MHD' && s63;
      el('buy').hidden = requiresReview;

      var review = el('review');
      if (review) review.hidden = !requiresReview;

      el('buy').disabled =
        buying ||
        !priceOK ||
        (state.mapCount > 0 && !hasMap);

      if (!priceOK) {
        showError('This Shopify variant is missing, unavailable, or mispriced. Contact M-Tech before ordering.');
      } else if (state.mapCount > 0 && !hasMap) {
        showError('Additional maps cannot be charged until the add-on product is configured.');
      } else if (requiresReview) {
        showError('S63 MHD tuning requires VIN/DME verification before payment. Submit a compatibility request below; M-Tech will contact you.');
      } else {
        showError('');
      }
    }

    function checkFields() {
      var vin = el('vin');
      vin.value = vin.value.trim().toUpperCase();
      var email = el('email');
      var phone = el('phone');
      var mods = el('mods');

      if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin.value)) {
        showError('Enter a valid 17-character VIN (letters I, O and Q are not valid).');
        vin.focus();
        return false;
      }

      if (!email.value.trim() || !email.checkValidity()) {
        showError('Enter a valid email address.');
        email.focus();
        return false;
      }

      if (phone.value.trim().length < 7) {
        showError('Enter a valid phone number.');
        phone.focus();
        return false;
      }

      if (!mods.value.trim()) {
        showError('Enter your vehicle modifications or type Stock.');
        mods.focus();
        return false;
      }

      return true;
    }

    function details() {
      var properties = {
        'Engine': state.engine,
        'Base Fuel': state.base + ' Octane',
        'Hardware': isS63() ? 'S63 Standard' : state.hardware,
        'Additional Fuel': state.extra,
        'Additional Custom Maps': String(state.mapCount),
        'VIN': el('vin').value.trim().toUpperCase(),
        'Customer Email': el('email').value.trim(),
        'Customer Phone': el('phone').value.trim(),
        'Vehicle Modifications': el('mods').value.trim()
      };

      mapRequestFields.forEach(function (slot) {
        if (!slot.input.disabled) {
          properties['Map ' + slot.index + ' Request'] =
            slot.input.value.trim() || 'No specific map preferences provided';
        }
      });

      return properties;
    }

    el('maps-minus').addEventListener('click', function () {
      if (state.mapCount > 0) state.mapCount--;
      refresh();
    });

    el('maps-plus').addEventListener('click', function () {
      if (state.mapCount < MAX_MAPS && findMap() && findMap().available) {
        state.mapCount++;
      }
      refresh();
    });

    root.querySelectorAll('[data-image]').forEach(function (button) {
      button.addEventListener('click', function () {
        var hero = root.querySelector('.mtech-tuning__hero');
        if (hero) {
          hero.src = button.dataset.image;
          hero.srcset = '';
          hero.alt = button.dataset.alt;
        }
      });
    });

    if (el('review')) {
      el('review').addEventListener('click', function () {
        if (!checkFields()) return;

        var contact = root.querySelector('#MTechS63Compatibility');

        if (!contact) {
          showError('Compatibility request form is unavailable. Please contact M-Tech.');
          return;
        }

        el('review-email').value = el('email').value.trim();
        el('review-phone').value = el('phone').value.trim();
        el('review-body').value =
          'MHD S63 VIN COMPATIBILITY REVIEW\n' +
          Object.entries(details()).map(function (entry) {
            return entry[0] + ': ' + entry[1];
          }).join('\n') +
          '\nPlease verify DME generation, software compatibility, and unlock requirements before accepting payment.';

        contact.requestSubmit();
      });
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      if (buying || !checkFields()) return;

      if (platform === 'MHD' && isS63()) {
        showError('S63 MHD purchases are on hold until VIN approval. Request a compatibility review first.');
        return;
      }

      var v = findVariant();
      var m = findMap();

      if (!v || !v.available || v.price !== expectedPrice()) {
        showError('Your selected variant is not configured correctly in Shopify.');
        return;
      }

      if (state.mapCount && (
        !m ||
        !m.available ||
        m.price !== (isS63() ? 35000 : 25000)
      )) {
        showError('Additional map pricing is not configured correctly in Shopify.');
        return;
      }

      buying = true;
      el('buy').disabled = true;
      el('buy').textContent = 'Adding configuration…';

      var configRef =
        'MTECH-' +
        Date.now().toString(36).toUpperCase() +
        '-' +
        Math.random().toString(36).slice(2,8).toUpperCase();

      var props = Object.assign(details(), {
        '_MTech Configuration Ref': configRef
      });

      var items = [{
        id: v.id,
        quantity: 1,
        properties: props
      }];

      if (state.mapCount) {
        items.push({
          id: m.id,
          quantity: state.mapCount,
          properties: {
            'For Tune': platform + ' / ' + state.engine,
            'Customer VIN': el('vin').value,
            '_MTech Configuration Ref': configRef
          }
        });
      }

      var route =
        (window.Shopify &&
         window.Shopify.routes &&
         window.Shopify.routes.root) || '/';

      try {
        var response = await fetch(route + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        });

        var data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            'Unable to add configuration.'
          );
        }

        window.location.assign(route + 'cart');

      } catch (error) {
        showError('Cart error: ' + error.message + '. No checkout has been started.');
        buying = false;
        el('buy').textContent = 'Add configured tune to cart';
        refresh();
      }
    });

    createMapRequestFields();
    refresh();
  }

  function init() {
    document.querySelectorAll('[data-mtech-tuning]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
